import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const EnrichmentOverviewScreen = lazy(
  () => import('~/features/item-setup/pages/enrichment-overview-screen'),
);

export const Route = createFileRoute('/_authenticated/_tenant/item-setup/enrichment-overview')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <EnrichmentOverviewScreen />
    </Suspense>
  ),
});
